import { ROOT_FONT_SIZE } from "theme/constants";
export const getDefaultLabelColor = (theme) => theme.colors.text.primary;
const getDefaultPlotFontSettings = (theme) => ({
  color: getDefaultLabelColor(theme),
  size: ROOT_FONT_SIZE * Number(theme.fonts.size.small.replace(/rem|em/i, "")),
  family: theme.fonts.family.body
});
export default getDefaultPlotFontSettings;
